
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import BillingTemplatesShowEdit from '@/components/billing-templates/show-edit-billing-template.vue'
import { useBillingTemplateModule } from '@/modules/billing-templates'
import { OrganizationsRouteNames } from '@/router/routes-names'
import useQuasar from 'quasar/src/composables/use-quasar.js';

export default defineComponent({
    name: 'view-billing-templates-show-billing-template',
    components: {
        BillingTemplatesShowEdit
    },
    async setup () {
        const route = useRoute()
        const $q = useQuasar()
        const { getBillingTemplate } = useBillingTemplateModule()

        const organizationId = route.params.organizationId as string
        const billingTemplateId = route.params.billingTemplateId as string
        let billingTemplate: unknown
        try {
            billingTemplate = await getBillingTemplate(organizationId, billingTemplateId)
        } catch (e) {
            $q.notify({
                color: 'negative',
                message: e.toString() || 'billingTemplate not found'
            })
        }

        return {
            organizationId,
            billingTemplateId,
            billingTemplate,
            OrganizationsRouteNames
        }
    }
})
